import React, { FC } from 'react'
import { Box, Typography } from 'transfix-ui/core'

interface ITeamMemberDetailFormTitleProps {
  /**
   * The title
   */
  children: string
  /**
   * Should we remove the top padding?
   * @default false
   */
  hidePaddingTop?: boolean
  /**
   * The component on the left (an avatar or an icon)
   */
  leftComponent?: JSX.Element
}

export const TeamMemberDetailFormTitle: FC<ITeamMemberDetailFormTitleProps> = ({
  children: title,
  hidePaddingTop = false,
  leftComponent,
}) => (
  <Box pt={hidePaddingTop ? 0 : 2} mb={1.5} display='flex' alignItems='center'>
    {leftComponent && (
      <Box pr={1} component='span'>
        {leftComponent}
      </Box>
    )}
    <Typography variant='subtitle1' component='span'>
      {title}
    </Typography>
  </Box>
)
